(()=>{
  if(customElements.get('hawkhurst-gift-selector'))return;
  class HawkhurstGiftSelector extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.data=JSON.parse(this.querySelector('[data-gift-data]').textContent);
      this.form=this.closest('form');
      this.section=this.closest('[data-section-type="product"]');
      this.button=this.form.querySelector('.ProductForm__AddToCart');
      this.showPrice=JSON.parse(this.section.dataset.sectionSettings).showPriceInButton;
      this.money=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:this.data.currency||'GBP',minimumFractionDigits:0,maximumFractionDigits:2});
      this.abort=new AbortController();const signal=this.abort.signal;
      this.addEventListener('change',()=>this.update(),{signal});
      this.section.addEventListener('variant:changed',()=>queueMicrotask(()=>this.update()),{signal});
      this.button.addEventListener('click',e=>{if(this.upgraded){e.preventDefault();e.stopImmediatePropagation();this.addBundle();}}, {capture:true,signal});
      this.form.addEventListener('submit',e=>{if(this.upgraded){e.preventDefault();e.stopImmediatePropagation();this.addBundle();}}, {capture:true,signal});
      this.setupMobile(signal);
      this.hidden=false;this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.mobileObserver?.disconnect();this.buttonObserver?.disconnect();this.sticky?.remove();this.form?.querySelectorAll('.HawkhurstScent').forEach(e=>e.remove());this.form?.querySelectorAll('.HawkhurstScentSwatches').forEach(e=>e.classList.remove('HawkhurstScentSwatches'));document.body.classList.remove('hawkhurst-mobile-cart');this.ready=false;}
    setupMobile(signal){
      this.scentSelects=[];
      this.form.querySelectorAll('.ProductForm__Option').forEach((group,index)=>{
        const radios=[...group.querySelectorAll('.SizeSwatch__Radio')];
        if(!radios.length)return;
        const select=document.createElement('select');
        select.className='HawkhurstScent';
        select.id='hawkhurst-scent-'+this.section.id+'-'+index;
        select.setAttribute('aria-label',group.querySelector('.ProductForm__Label')?.textContent.trim()||radios[0].name);
        radios.forEach(radio=>select.add(new Option(radio.value,radio.value,false,radio.checked)));
        select.addEventListener('change',()=>radios.find(r=>r.value===select.value)?.click(),{signal});
        group.querySelector('.SizeSwatchList').classList.add('HawkhurstScentSwatches');
        group.append(select);
        this.scentSelects.push({select,radios});
      });
      if(this.data.mobileSticky===false)return;
      this.sticky=document.createElement('div');this.sticky.className='HawkhurstMobileCart';this.sticky.hidden=true;
      this.stickyButton=document.createElement('button');this.stickyButton.type='button';this.stickyButton.className='Button Button--primary Button--full';
      this.stickyButton.addEventListener('click',()=>{
        if(this.button.disabled)return;
        const quantity=this.form.querySelector('[name="quantity"]');
        if(quantity&&!quantity.checkValidity()){quantity.scrollIntoView({block:'center'});quantity.reportValidity();return;}
        this.button.click();
      },{signal});
      this.sticky.append(this.stickyButton);document.body.append(this.sticky);
      const refresh=()=>{if(this.mobileFrame)return;this.mobileFrame=requestAnimationFrame(()=>{this.mobileFrame=null;this.syncMobile();});};
      window.addEventListener('scroll',refresh,{passive:true,signal});window.addEventListener('resize',refresh,{passive:true,signal});
      window.visualViewport?.addEventListener('resize',refresh,{passive:true,signal});
      this.mobileObserver=new MutationObserver(refresh);
      this.mobileObserver.observe(document.body,{subtree:true,attributes:true,attributeFilter:['aria-hidden','class']});
      this.buttonObserver=new MutationObserver(refresh);this.buttonObserver.observe(this.button,{attributes:true,attributeFilter:['disabled']});
      this.form.addEventListener('change',refresh,{signal});
    }
    syncMobile(){
      this.scentSelects.forEach(({select,radios})=>{select.value=radios.find(r=>r.checked)?.value||'';});
      if(!this.sticky)return;
      const {original,bundle}=this.selected();const chosen=this.upgraded?bundle:original;
      this.stickyButton.textContent=(chosen?.available?this.data.addLabel:this.data.soldOutLabel)+(chosen?' · '+this.format(chosen.price):'');
      this.stickyButton.disabled=this.button.disabled||!!this.busy;
      const visible=e=>{if(!e)return false;const r=e.getBoundingClientRect();return r.width>0&&r.height>0&&getComputedStyle(e).visibility!=='hidden'&&getComputedStyle(e).display!=='none';};
      const overlay=[...document.querySelectorAll('.Drawer[aria-hidden="false"],.Modal[aria-hidden="false"],[role="dialog"][aria-modal="true"],#shopify-pc__banner')].some(visible);
      const preview=document.querySelector('#PBarNextFrameWrapper,#preview-bar-iframe');
      const offset=visible(preview)?Math.max(0,innerHeight-preview.getBoundingClientRect().top):0;
      this.sticky.style.bottom=offset+'px';
      document.body.style.setProperty('--hawkhurst-cart-offset',offset+'px');
      const rect=this.button.getBoundingClientRect();
      const normalVisible=rect.top>=90&&rect.bottom<=innerHeight-offset;
      this.sticky.hidden=!matchMedia('(max-width: 640px)').matches||overlay||normalVisible;
      document.body.classList.toggle('hawkhurst-mobile-cart',!this.sticky.hidden);
    }
    get upgraded(){return this.querySelector('input[value="brush"]').checked;}
    format(value){return this.money.format(value/100);}
    selected(){
      const id=this.form.querySelector('[name="id"]')?.value;
      const original=this.data.original.find(v=>String(v.id)===id);
      const bundle=original&&this.data.bundle.find(v=>v.options.every((o,i)=>o===original.options[this.data.bundleOptionNames?this.data.originalOptionNames.indexOf(this.data.bundleOptionNames[i]):i]));
      return {original,bundle};
    }
    update(){
      const {original,bundle}=this.selected();
      if(!original)return;
      const chosen=this.upgraded?bundle:original;
      const enabled=!!chosen?.available;
      this.querySelector('[data-gift-original-price]').textContent=this.format(original.price);
      this.querySelector('[data-gift-bundle-price]').textContent=this.format(bundle?.price??this.data.bundle[0].price);
      const extra=(bundle?.price??this.data.bundle[0].price)-original.price;
      const saving=original.price+this.data.brushPrice-(bundle?.price??this.data.bundle[0].price);
      this.querySelector('[data-gift-saving]').textContent=this.data.addFor.replace('__AMOUNT__',this.format(extra))+(saving>0?' · '+this.data.save.replace('__AMOUNT__',this.format(saving)):'');
      this.section.classList.toggle('Product--hawkhurst-upgrade',this.upgraded);
      this.section.querySelectorAll('.ProductMeta__Price').forEach(e=>e.textContent=this.format(chosen?.price??original.price));
      const label=document.createElement('span');label.textContent=enabled?this.data.addLabel:this.data.soldOutLabel;
      if(enabled&&this.showPrice){const dot=document.createElement('span');dot.className='atc_dot';const price=document.createElement('span');price.className='atc_price';price.textContent=this.format(chosen.price);label.append(dot,price);}
      this.button.replaceChildren(label);this.button.disabled=!enabled||!!this.busy;
      if(enabled)this.button.dataset.action='add-to-cart';else this.button.removeAttribute('data-action');
      const error=this.querySelector('[data-gift-error]');error.hidden=enabled;error.textContent=enabled?'':this.data.unavailable;
      this.syncMobile();
    }
    async addBundle(){
      if(this.busy)return;
      const {bundle}=this.selected();if(!bundle?.available){this.update();return;}
      const quantity=Number(this.form.querySelector('[name="quantity"]')?.value||1);
      if(!Number.isSafeInteger(quantity)||quantity<1){this.form.querySelector('[name="quantity"]')?.focus();return;}
      this.busy=true;this.button.disabled=true;this.querySelector('[data-gift-error]').hidden=true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      try{
        const root=window.Shopify?.routes?.root||'/';
        const properties={};new FormData(this.form).forEach((value,key)=>{const m=key.match(/^properties\[(.+)\]$/);if(m)properties[m[1]]=value;});
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:bundle.id,quantity,properties}]})});
        const result=await response.json();if(!response.ok)throw Error(result.description||result.message||this.data.error);
        this.section.dispatchEvent(new CustomEvent('product:added',{bubbles:true,detail:{variant:bundle,quantity}}));
        if(window.theme?.cartType==='page')window.location.assign(root+'cart');
      }catch(error){const node=this.querySelector('[data-gift-error]');node.textContent=error.message||this.data.error;node.hidden=false;node.scrollIntoView({block:'center',behavior:'smooth'});}
      finally{this.busy=false;this.button.disabled=!this.selected().bundle?.available;document.dispatchEvent(new CustomEvent('theme:loading:end'));}
    }
  }
  customElements.define('hawkhurst-gift-selector',HawkhurstGiftSelector);
})();

